import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const CertificateQR = ({ certId }) => {
  // لینکی که کاربر با اسکن کردن به آن هدایت می‌شود
  const verificationUrl = `https://www.pythonteek.com/`;

  return (
    <div style={{position:"absolute", top:"81%",left:"35%"}}>
    
      <QRCodeSVG
        value={verificationUrl}
        size={80}               
        bgColor={"#ffffff"}      
        fgColor={"#000000"}      
        level={"H"}              
        
      />
      
      <p style={{ marginTop: '10px', fontSize: '12px' }}>
        {/* کد شناسایی: {certId} */}
      </p>
    </div>
  );
};

export default CertificateQR;